// assets/morak-protection-gallery.js
(function () {
  const DEBOUNCE_MS = 120;

  // --- Helpers ---
  function norm(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function sanitizeUrl(u) {
    if (!u) return "";
    // Si es objeto (video), lo pasamos tal cual
    if (typeof u === "object") return u;
    let url = String(u).trim();
    url = url.replace(/\/files\/files\//g, "/files/");
    url = url.replace(/(cdn\/shop\/files)\/files\//g, "$1/");
    return url;
  }

  function getConfig(root = document) {
    const el = root.querySelector("script[data-morak-protection-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return null;
    }
  }

  function mapProtectionToTypeCode(label) {
    const t = norm(label);

    // 1.5m (Slim Guard)
    if (t.includes("1.5m")) return "S";

    // 5m
    if (t.includes("5m")) return "T";

    // 3m (siempre viene con blanco o negro)
    if (t.includes("3m")) {
      if (t.includes("negro")) return "N";
      if (t.includes("blanco")) return "B";
    }

    return null;
  }


  function getProtectionLabel(scope = document) {
    const texts = [];

    // selects
    scope.querySelectorAll("select").forEach((sel) => {
      const opt = sel.options?.[sel.selectedIndex];
      if (opt?.textContent) texts.push(opt.textContent.trim());
    });

    // radios
    scope.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      const lab = r.id ? scope.querySelector(`label[for="${CSS.escape(r.id)}"]`) : null;
      texts.push(((lab && lab.textContent) || r.value || "").trim());
    });

    const clean = texts.filter(Boolean);

    const candidates = clean.filter((x) => {
      const n = norm(x);
      return (
        n.includes("protección") ||
        n.includes("proteccion") ||
        n.includes("1.5m") ||
        n.includes("3m") ||
        n.includes("5m")
      );
    });

    if (!candidates.length) return "";

    // prioridad: 1.5m > 3m > 5m > "proteccion"
    const pick =
      candidates.find(x => norm(x).includes("1.5m")) ||
      candidates.find(x => norm(x).includes("3m"))   ||
      candidates.find(x => norm(x).includes("5m"))   ||
      candidates.find(x => {
        const n = norm(x);
        return n.includes("protección") || n.includes("proteccion");
      }) ||
      "";

    return pick;


  }

  function removeGeneric(mediaGallery) {
    mediaGallery.querySelectorAll('[data-morak-generic="true"]').forEach((n) => n.remove());
  }

  function setImgUrlDeep(rootEl, url) {
    rootEl.querySelectorAll("img").forEach((img) => {
      img.setAttribute("src", url);
      img.removeAttribute("srcset");
      img.removeAttribute("data-src");
      img.removeAttribute("data-srcset");
    });

    rootEl.querySelectorAll("source").forEach((s) => {
      s.removeAttribute("srcset");
      s.removeAttribute("data-srcset");
    });
  }

  // --- Slideshow (carousel) ---
  
  function appendGenericToSlideshow(mediaGallery, items) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return false;

    const slides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"));
    if (!slides.length) return false;

    const template = slides[slides.length - 1].cloneNode(true);
    const baseIndex = slides.length;

    items.slice(0, 5).forEach((raw, k) => {
      const item = sanitizeUrl(raw);
      if (!item) return;

      const isVideo = typeof item === "object" && item.type === "video";

      const slide = template.cloneNode(true);
      slide.setAttribute("data-morak-generic", "true");
      slide.querySelectorAll("[data-media-id]").forEach((el) => el.removeAttribute("data-media-id"));

      const idx = baseIndex + k;
      slide.style.setProperty("view-timeline-name", `--slide-${idx}`);
      slide.querySelector(".product-media-container__zoom-button")?.remove();

      if (isVideo) {
        const container = slide.querySelector(".product-media-container") || slide;
        container.innerHTML = `
          <video
            src="${item.src}"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            style="
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              background: transparent;
            "
          ></video>`;
      } else {
        setImgUrlDeep(slide, item);  // ← esto no lo tocas
      }

      slidesRoot.appendChild(slide);
    });

    // Actualiza timeline
    const slideshow = mediaGallery.querySelector("slideshow-component");
    if (slideshow) {
      const allSlides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"));
      const names = allSlides.map((_, i) => `--slide-${i}`);
      slideshow.style.setProperty("--slideshow-timeline", names.join(", "));
    }

    return true;
  }

  function getActiveNativeMediaId(mediaGallery) {
    const activeSlide = mediaGallery.querySelector("slideshow-slide[aria-hidden='false']");
    const media = activeSlide?.querySelector("[data-media-id]");
    return media?.getAttribute("data-media-id") || null;
  }

  function hideOtherNativeSlides(mediaGallery, keepMediaId) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return;

    slidesRoot.querySelectorAll(":scope > slideshow-slide").forEach((slide) => {
      const isGeneric = slide.getAttribute("data-morak-generic") === "true";
      if (isGeneric) {
        slide.style.removeProperty("display");
        return;
      }

      // si no tenemos activo, no tocamos nada
      if (!keepMediaId) {
        slide.style.removeProperty("display");
        return;
      }

      const mediaId = slide.querySelector("[data-media-id]")?.getAttribute("data-media-id");
      if (mediaId && mediaId !== keepMediaId) {
        slide.style.display = "none";
        slide.setAttribute("aria-hidden", "true");
      } else {
        slide.style.removeProperty("display");
      }
    });
  }

  function refreshSlideshowLayout(mediaGallery) {
    const slideshow = mediaGallery.querySelector("slideshow-component");
    if (!slideshow) return;

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
      requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
    });
  }

    // --- Arrow fix (force scroll-based navigation) ---
  function getSlidesRoot(mediaGallery) {
    return mediaGallery.querySelector("slideshow-slides");
  }

  function getSlideWidth(slidesRoot) {
    const slide = slidesRoot?.querySelector(":scope > slideshow-slide:not([style*='display: none'])");
    if (!slide) return 0;
    return slide.getBoundingClientRect().width || 0;
  }

  function getCurrentIndex(slidesRoot, slideW) {
    if (!slidesRoot || !slideW) return 0;
    return Math.round(slidesRoot.scrollLeft / slideW);
  }

  function scrollToIndex(slidesRoot, idx) {
    if (!slidesRoot) return;
    const slideW = getSlideWidth(slidesRoot);
    if (!slideW) return;
    slidesRoot.scrollTo({ left: idx * slideW, behavior: "smooth" });
  }

  function installArrowFix(mediaGallery) {
    if (!mediaGallery || mediaGallery.__morakArrowFixInstalled) return;
    mediaGallery.__morakArrowFixInstalled = true;

    // Captura clicks de flechas y fuerza scroll.
    mediaGallery.addEventListener(
      "click",
      (e) => {
        const btn = e.target?.closest?.("button.slideshow-control");
        if (!btn) return;

        // Solo dentro de este media-gallery
        if (!mediaGallery.contains(btn)) return;

        const slidesRoot = getSlidesRoot(mediaGallery);
        if (!slidesRoot) return;

        const slideW = getSlideWidth(slidesRoot);
        if (!slideW) return;

        // Prev/Next
        const isPrev = btn.classList.contains("slideshow-control--previous");
        const isNext = btn.classList.contains("slideshow-control--next");
        if (!isPrev && !isNext) return;

        // Si el theme tiene lógica interna “dañada”, la anulamos
        e.preventDefault();
        e.stopPropagation();

        const slides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"))
          .filter((s) => s.style.display !== "none");
        const max = Math.max(0, slides.length - 1);

        const cur = getCurrentIndex(slidesRoot, slideW);
        const next = Math.min(max, Math.max(0, cur + (isNext ? 1 : -1)));

        scrollToIndex(slidesRoot, next);
      },
      true // capture
    );
  }


  // --- Scheduling ---
  let lastAppliedKey = null;
  let timer = null;

  function scheduleRun(reason = "") {
    clearTimeout(timer);
    timer = setTimeout(() => run(reason), DEBOUNCE_MS);
  }

  function runAfterRerender(reason) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scheduleRun(reason);
      });
    });
  }

  function run(reason = "") {
    const scope = document.querySelector(".product-information") || document;

    const mediaGallery =
      scope.querySelector("media-gallery") ||
      document.querySelector("main media-gallery") ||
      document.querySelector("media-gallery");

    if (!mediaGallery) return;

    const cfg = getConfig(mediaGallery);
    if (!cfg?.typeGalleries) return;

    const protLabel = getProtectionLabel(scope);
    const type = mapProtectionToTypeCode(protLabel);

    const urls = (cfg.typeGalleries?.[type] || []).map(sanitizeUrl).filter(Boolean);



    window.__MORAK_LAST_PICK = { reason, protLabel, type, count: urls.length };

    if (!type || !urls.length) return;

    const key = `${type}::${urls.join("|")}`;
    if (key === lastAppliedKey && mediaGallery.querySelector('[data-morak-generic="true"]')) return;

    removeGeneric(mediaGallery);

    const didSlides = appendGenericToSlideshow(mediaGallery, urls);

    installArrowFix(mediaGallery);


    const activeId = getActiveNativeMediaId(mediaGallery);
    hideOtherNativeSlides(mediaGallery, activeId);

    if (didSlides) refreshSlideshowLayout(mediaGallery);

    lastAppliedKey = key;
    window.__MORAK_LAST_APPLY = { didSlides, key };
  }

  // ✅ Nuevo: detecta re-render en móvil (reemplazos silenciosos del media-gallery)
  function installObserver() {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        // Si agregan/reemplazan nodos que incluyan media-gallery o slideshow-slides, re-aplica
        const added = Array.from(m.addedNodes || []);
        if (
          added.some(
            (n) =>
              n.nodeType === 1 &&
              (n.matches?.("media-gallery") ||
                n.querySelector?.("media-gallery") ||
                n.matches?.("slideshow-slides") ||
                n.querySelector?.("slideshow-slides"))
          )
        ) {
          runAfterRerender("mutation");
          break;
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    scheduleRun("init");
    installObserver();

    // cambios de selects / radios
    document.addEventListener(
      "change",
      (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        if (el.closest("variant-picker") || el.closest("product-form") || el.closest(".product-information")) {
          scheduleRun("change");
        }
      },
      true
    );

    document.addEventListener(
      "click",
      (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        if (el.closest("variant-picker") || el.closest("product-form") || el.closest(".product-information")) {
          scheduleRun("click");
        }
      },
      true
    );

    // eventos de variante (distintos themes/móvil)
    ["variantUpdate", "variant:change", "variantChange", "product:variant-change"].forEach((evt) => {
      document.addEventListener(
        evt,
        () => {
          runAfterRerender(evt);
        },
        true
      );
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
